import { render, staticRenderFns } from "./SpecialTopicPage.vue?vue&type=template&id=78baa72c&scoped=true&"
import script from "./SpecialTopicPage.vue?vue&type=script&lang=ts&"
export * from "./SpecialTopicPage.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialTopicPage.vue?vue&type=style&index=0&id=78baa72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78baa72c",
  null
  
)

export default component.exports